<template>
<div>


  <div class="scrollIcon" id="scroll" @click="scrollToTop()">
    <div id="star-svg" v-show="isVisible" class="animated" ref="scrollIcon">
      <svg height="200" width="59" viewBox="0 0 200 200" class="progress">
        <path
          stroke="#5d409f"
          stroke-width="9"
          id="star-path"
          d="
            M 100, 100
            m -75, 0
            a 75,75 0 1,0 150,0
            a 75,75 0 1,0 -150,0
            "
        />
      </svg>
    </div>
  </div>

</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    let me = this;
    var path = document.querySelector("#star-path");
    var pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength + " " + pathLength;
    path.style.strokeDashoffset = pathLength;
    path.getBoundingClientRect();
    window.addEventListener("scroll", function(e) {
      me.handleScroll();
      var scrollPercentage =
        (document.documentElement.scrollTop + document.body.scrollTop) /
        (document.documentElement.scrollHeight -
          document.documentElement.clientHeight);
      var drawLength = pathLength * scrollPercentage;
      path.style.strokeDashoffset = pathLength + drawLength;
      if (scrollPercentage >= 0.99) {
        path.style.strokeDasharray = "none";
      } else {
        path.style.strokeDasharray = pathLength + " " + pathLength;
      }
    });
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll(event) {
      let scrolled = window.scrollY > window.screen.height;
      this.$refs.scrollIcon.classList.remove("fadeInUp");
      this.$refs.scrollIcon.classList.remove("fadeOutDown");

      if (scrolled) {
        this.$refs.scrollIcon.classList.add("fadeInUp");
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/animate.css";
@keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
}
@-webkit-keyframes fadeInUp {
  0% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animated {
  animation-duration: 0.4s !important;
  animation-iteration-count: 1 !important;
  -webkit-animation-duration: 0.4s !important;
  -webkit-animation-iteration-count: 1 !important;
}
.fadeInUp {
  -webkit-animation-name: fadeInUp !important;
  animation-name: fadeInUp !important;
}

@keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}
@-webkit-keyframes fadeOutDown {
  0% {
    transform: rotate(360deg) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: rotate(360deg) translate3d(0, 50%, 0);
    opacity: 0;
  }
}

.fadeOutDown {
  -webkit-animation-name: fadeOutDown !important;
  animation-name: fadeOutDown !important;
}

.arrowTop {
  width: 19px;
  z-index: 2;
  position: fixed;
  right: 77px;
  bottom: 168px;
}

svg path {
  fill: #fff;
  stroke-dasharray: 100;
  border: solid 1px #d2d2d2;
}
#star-svg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  opacity: 1;
  z-index: 2;
  position: fixed;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #fff;
  bottom: 190px;
  right: 3%;
}
@keyframes moveArrow {
  0% {
    transform: rotate(-60deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

@-webkit-keyframes moveArrow {
  0% {
    transform: rotate(-60deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

#star-svg:before {
  position: absolute;
  content: "\2191";
  text-align: center;
  line-height: 38px;
  font-size: 50px;
  right: 6px;
  box-shadow: inset 0 0 0 3px rgba(210, 210, 210, 0.4);
  bottom: -63px;
  height: 47px;
  border-radius: 50%;
  width: 47px;
  cursor: pointer;
  display: block;
  z-index: 2;
  -webkit-transition: all 200ms linear;
  transition: all 200ms linear;
  color: #5d409f;
  -webkit-animation: moveArrow 0.4s ease-out;
  animation: moveArrow 0.4s ease-out;
  -webkit-transition: all 0.4s ease-in;
  transition: all 0.4s ease-in;
}

#scroll-top {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  z-index: 2;
  position: fixed;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #fff;
  bottom: 190px;
  right: 3%;
  &:hover {
    cursor: pointer;
  }
}
.progress {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}
</style>
